import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_50() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter November 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            South Africa Proposes Climate Transition-Planning Framework for
            Financial Institutions.
          </title>
          <meta
            name="description"
            content="South Africa’s National Treasury has launched a public consultation on its proposed Climate Transition Planning and Disclosure Framework, aimed at strengthening climate risk management across the financial sector."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          South Africa Proposes Climate Transition-Planning Framework for
          Financial Institutions.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/November_2026_1.webp")}
            alt="South Africa Proposes Climate Transition-Planning Framework for Financial Institutions."
            loading="lazy"
          />
        </figure>
        <p>
          South Africa’s National Treasury has launched a public consultation on
          its proposed Climate Transition Planning and Disclosure Framework,
          aimed at strengthening climate risk management across the financial
          sector. Announced in October 2026, the initiative seeks to establish
          practical guidelines for banks, insurers, asset managers, and
          investors to develop credible transition plans aligned with national
          climate objectives and international practices.
        </p>
        <p>
          The proposed framework integrates climate mitigation, adaptation, and
          just transition considerations into financial decision-making.
          According to National Treasury, South Africa’s climate transition
          investment requirements are estimated to average 4.4% of GDP annually
          through 2050. The consultation paper addresses policy foundations,
          financial sector preparedness, and proposed principles for consistent
          transition planning and disclosure.
        </p>
        <p>
          The consultation invites financial institutions, regulators,
          businesses, academia, and civil society to contribute recommendations.
          Key priorities include proportionate implementation, reliable climate
          data, institutional capacity, and alignment between corporate
          transition strategies and financing decisions, supporting transparent
          climate-related disclosures and sustainable investment planning across
          South Africa’s financial system.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The proposal reflects South Africa’s particular need to balance
            emissions reduction, climate adaptation, economic development and a
            just transition. Transition plans are becoming an important layer
            between sustainability disclosures and actual financing decisions.
            Financial institutions need to demonstrate how climate targets
            influence sector policies, portfolio allocation, risk appetite and
            client engagement.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Brazil Opens Public Consultation on Expanded Sustainable Finance
          Taxonomy.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/November_2026_2.webp")}
              alt="Brazil Opens Public Consultation on Expanded Sustainable Finance Taxonomy."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          Brazil’s Ministry of Finance has launched a public consultation on the
          second edition of the Brazilian Sustainable Taxonomy (TSB),
          strengthening the country’s framework for classifying environmentally
          and socially sustainable economic activities and investments. The
          initiative seeks to improve transparency, establish consistent
          sustainability criteria, and support informed capital allocation
          across economic sectors while promoting alignment with national
          environmental and development priorities.
        </p>
        <p>
          The revised taxonomy introduces four additional objectives covering
          biodiversity, ecosystem services, sustainable land and forest
          management, circular economy practices, and regional inequality
          reduction. It also expands coverage of rural economic activities,
          reflecting Brazil’s environmental priorities and sustainable
          development agenda. These additions complement existing climate and
          sustainability objectives while supporting the integration of
          environmental, social, and governance considerations into financial
          decision-making.
        </p>
        <p>
          The consultation follows a two-stage process. The first stage, running
          from October 16 to November 20, 2026, covers eight sectoral technical
          documents and one socioeconomic document. The second, scheduled from
          November 9 to December 4, addresses conformity assessment frameworks
          for debt instruments, financing, and forestry-related activities.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Brazil is positioning the taxonomy as an environmental and social
            classification system rather than a climate-only framework. Banks
            and investors will require detailed evidence to show whether
            financed activities meet its technical criteria. The proposal also
            extends coverage of rural economic activities and value chains.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          European Commission Proposes New Climate Resilience Framework to
          Strengthen Adaptation and Risk Preparedness.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/November_2026_3.webp")}
            alt="European Commission Proposes New Climate Resilience Framework to Strengthen Adaptation and Risk Preparedness."
            loading="lazy"
          />
        </figure>
        <p>
          The European Commission has proposed a new Climate Resilience
          Framework, introducing a European climate resilience law to strengthen
          preparedness against extreme weather events. The initiative
          establishes a coordinated approach to climate risk assessment,
          adaptation planning, and infrastructure protection, supporting public
          authorities, businesses, and communities in managing climate-related
          challenges across the European Union.
        </p>
        <p>
          The proposal builds on growing evidence of climate-related economic
          exposure. According to the European Environment Agency, extreme
          weather and climate events caused approximately €822 billion in
          economic losses across the EU between 1980 and 2024. The European
          Climate Risk Assessment identified 36 major climate risks affecting
          ecosystems, food security, public health, infrastructure, and
          financial stability, highlighting the importance of coordinated
          adaptation strategies.
        </p>
        <p>
          The framework introduces supporting resources, including the European
          Climate Viewer, Navigator of Climate Resilience Tools, and Mission
          Solutions Explorer. Additional planned measures include a European
          heatwave plan, climate insurance alliance, and European water
          initiative. The Commission also intends to identify 100
          climate-vulnerable territories, supporting targeted adaptation
          measures and regional resilience planning across Europe.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The European climate-resilience framework is designed to create a
            more consistent approach to identifying, assessing and managing
            physical climate risks. It is intended to support public
            authorities, businesses, infrastructure operators and communities.
            The EU Climate Resilience Framework can contribute to economic
            stability by reducing climate-related financial losses, protecting
            critical infrastructure, and strengthening preparedness for extreme
            weather events. Coordinated adaptation measures can support
            sustainable investment, improve resource efficiency, and reduce
            pressure on public finances.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Nigeria SEC Sets Compliance Requirements for IFRS Sustainability
          Disclosure Standards.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/November_2026_4.webp")}
            alt="Nigeria SEC Sets Compliance Requirements for IFRS Sustainability Disclosure Standards."
            loading="lazy"
          />
        </figure>
        <p>
          Nigeria’s Securities and Exchange Commission (SEC) has directed public
          companies and significant public-interest capital market operators to
          comply with requirements for implementing IFRS Sustainability
          Disclosure Standards. Under its September 2026 circular, affected
          entities were required to submit implementation plans by October 15,
          2026. The directive establishes regulatory expectations for adopting
          IFRS S1 and IFRS S2, covering sustainability-related financial
          disclosures and climate-related risks and opportunities.
        </p>
        <p>
          The implementation plans must outline governance structures, board
          oversight responsibilities, reporting processes, gap assessments,
          internal control mechanisms, and staff capacity development. Entities
          are also expected to establish procedures for identifying material
          sustainability risks, collecting relevant data, and preparing
          disclosures consistent with the standards. IFRS S2 additionally
          requires information on greenhouse gas emissions, climate-related
          targets, and risk management processes.
        </p>
        <p>
          Nigeria’s phased adoption framework provides for voluntary reporting
          from 2024 to 2027, mandatory compliance for public-interest entities
          beginning in January 2028, and requirements for small and medium-sized
          enterprises from January 2030. The SEC directive also addresses
          implementation readiness, assurance arrangements, and reporting
          accountability.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Nigeria is moving beyond policy endorsement towards organisational
            readiness. Reporting entities will need to establish ownership of
            sustainability information and connect financial-reporting controls
            with emissions and climate-related data. Nigeria’s implementation of
            IFRS Sustainability Disclosure Standards strengthens regulatory
            oversight, corporate accountability, and transparency in
            sustainability reporting
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Mexico Prepares National Adaptation Plan and Territorial Climate-Risk
          Platform.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/November_2026_5.webp")}
            alt="Mexico Prepares National Adaptation Plan and Territorial Climate-Risk Platform."
            loading="lazy"
          />
        </figure>

        <p>
          Mexico has outlined plans to integrate climate justice, environmental
          protection, and social equity into its national development framework.
          During an environmental justice forum in October 2026, the Ministry of
          Environment and Natural Resources emphasized ecosystem conservation,
          sustainable economic activities, and community resilience. The
          government is preparing a National Adaptation Plan for COP31,
          supported by geospatial tools to help communities identify climate
          risks and strengthen local preparedness.
        </p>
        <p>
          The initiative aligns with Mexico’s climate commitments, including a
          35% greenhouse gas emissions reduction target by 2030. Its updated
          climate contribution establishes an unconditional emissions ceiling of
          364–404 million tonnes of carbon dioxide equivalent by 2035. Proposed
          environmental tax reforms would direct revenues toward ecosystem
          restoration, while payment mechanisms would support communities
          conserving forests and biodiversity.
        </p>
        <p>
          Mexico also reported recovering 306,000 hectares of mining concessions
          within protected natural areas and plans to restore approximately
          59,000 hectares across 76 priority sites. Environmental governance
          measures emphasize public participation, access to environmental
          information, and judicial protections under the Escazú Agreement,
          alongside renewable energy, circular economy practices, and
          sustainable resource management.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Mexico’s climate justice approach reflects an emerging ESG
            governance model linking environmental restoration, social equity,
            and regulatory accountability. Integrating adaptation planning,
            biodiversity protection, and community participation into national
            policy strengthens climate risk management, supports equitable
            resource allocation, and establishes measurable pathways for
            embedding environmental justice within sustainable development
            frameworks.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_50;
